import { boot } from 'quasar/wrappers'
import { defineRule } from 'vee-validate'
import {
  required,
  min_value as minValue,
  max_value as maxValue,
} from '@vee-validate/rules'

export default boot((/* { app, router, ... } */) => {
  defineRule('reqired', required)
  defineRule('minValue', minValue)
  defineRule('maxValue', maxValue)
})
